import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import { PromotionCountryOverview, PromotionCountryRunStatus } from '@app/model/promotion/PromotionCountryOverview';
import {
	FIND_PROMOTION_COUNTRY_OVERVIEW_QUERY,
	GET_PROMOTION_COUNTRY_RUN_STATUS_QUERY,
	TRIGGER_PROMOTION_COUNTRY_RUN_MUTATION,
} from '@app/model/promotion/service/PromotionCountryGraphQLQueries';

export type PromotionCountryVariables = {
	companyHotelId: number;
};

export default class PromotionCountryService {
	public static find(variables: PromotionCountryVariables) {
		return GraphQLExecutor.execute<PromotionCountryOverview>(FIND_PROMOTION_COUNTRY_OVERVIEW_QUERY, variables);
	}

	public static runStatus(variables: { companyHotelId: number }) {
		return GraphQLExecutor.execute<PromotionCountryRunStatus>(GET_PROMOTION_COUNTRY_RUN_STATUS_QUERY, variables);
	}

	public static triggerRun(variables: PromotionCountryVariables) {
		return GraphQLExecutor.execute<PromotionCountryRunStatus>(TRIGGER_PROMOTION_COUNTRY_RUN_MUTATION, variables);
	}
}

export const PromotionCountryQueryKeys = {
	all: ['promotion-country'] as const,
	overview: (companyHotelId: number) =>
		[...PromotionCountryQueryKeys.all, 'overview', companyHotelId] as const,
	runStatus: (companyHotelId: number) => [...PromotionCountryQueryKeys.all, 'run-status', companyHotelId] as const,
};
